<p class="mb-0 mt-2" *ngIf="fieldDescription">
  {{ fieldDescription }}{{ getRequired() ? '*' : '' }}
</p>

<mat-form-field 
  appearance="outline" 
  floatLabel="always" 
  *ngIf="!readonly" 
  class="w-100 mb-3" 
  [ngClass]="{ 'allow-pointer': tooltipText, 'no-label': hideLabel }">
  
  <mat-label>
    {{ labelOverride || fgInfo?.label }}{{ formControl['condrequired'] || fgInfo?.required ? '*' : '' }}
    <mat-icon 
      [hidden]="!tooltipText" 
      [matTooltip]="tooltipText" 
      [matTooltipPosition]="'after'" 
      [attr.aria-label]="'Tooltip: ' + tooltipText" 
      tabindex="0">
      help
    </mat-icon>
  </mat-label>

  <input 
    matInput 
    [attr.data-automation-id]="dataAutomationId" 
    [required]="fgInfo.required" 
    [matDatepicker]="picker" 
    [placeholder]="placeholder" 
    [formControl]="formControl" 
    (dateChange)="dateChanged($event)" />

  <!-- USE matIconSuffix FOR PROPER ALIGNMENT IN M3 -->
  <mat-datepicker-toggle matIconSuffix [for]="picker" *ngIf="!disabled"></mat-datepicker-toggle>
  
  <mat-datepicker #picker></mat-datepicker>

  <mat-hint *ngIf="!disabled">{{ hint }}</mat-hint>
<!-- 
  <mat-error *ngFor="let errorDefinition of errorDefinitions">
    <ng-container *ngIf="formControl.touched && errorDefinition.showFunction()">
      {{ errorDefinition.errorMessage(formControl) }}
    </ng-container>
  </mat-error> -->
 <mat-error *ngIf="errorDefinitions?.length">
    <ng-container *ngFor="let errorDefinition of errorDefinitions">
      <span *ngIf="formControl?.touched && errorDefinition.showFunction() && errorDefinition.errorMessage(formControl)"> {{ errorDefinition.errorMessage(formControl) }}</span>
    </ng-container>
  </mat-error>
  <mat-error *ngIf="formControl.touched && (formControl.hasError('invalidDateFormat') || formControl.hasError('matDatepickerParse'))">
    Date is invalid. Format is MM/DD/YYYY.
  </mat-error>
</mat-form-field>

<ng-container *ngIf="readonly">
  <mat-form-field 
    appearance="outline" 
    class="no-underline w-100" 
    [floatLabel]="'always'" 
    [ngClass]="{ 'read-only': readonly, 'allow-pointer': tooltipText, 'no-label': hideLabel }">
    
    <mat-label>
      {{ labelOverride || fgInfo?.label }}
      <mat-icon [hidden]="!tooltipText" [matTooltip]="tooltipText" [matTooltipPosition]="'after'" [attr.aria-label]="'Tooltip: ' + tooltipText">
        help
      </mat-icon>
    </mat-label>

    <input 
      *ngIf="!showEstOnReadOnly" 
      matInput 
      readonly 
      [attr.data-automation-id]="dataAutomationId" 
      [value]="formControl.value | utcMoment | dateFormat" 
      tabindex="-1" />
      
    <input 
      *ngIf="showEstOnReadOnly" 
      matInput 
      readonly 
      [attr.data-automation-id]="dataAutomationId" 
      [value]="formControl.value | easternMoment | dateFormat" 
      tabindex="-1" />
  </mat-form-field>
</ng-container>
